import React, { useCallback, useMemo, useState } from 'react';
import QrReader from 'react-qr-reader'
import useAppID from '../hooks/useAppId';
import useClipboard from '../hooks/useClipboard';
import useSendPaste from '../hooks/useSendPaste';

export default function Share(props: any) {
    const [receiver, setReceiver] = useState('');
    const { sendPaste, loading } = useSendPaste();
    const clipboard = useClipboard();
    const ID = useAppID()

    const handleScan = (data: any) => {
        console.log(data)
        setReceiver(data)
    }

    const handleError = (err: any) => {
        console.log('Error::', err)
    }

    const sharePaste = useCallback(() => {
        sendPaste({
            variables: {
                paste: {
                    receiver,
                    content: clipboard,
                    sender: ID
                }
            }
        })
    }, [sendPaste, clipboard, ID, receiver])

    return (
        <>
            {!receiver && <QrReader style={{ width: '50%' }} delay={3000} onError={handleError} onScan={handleScan} />}
            {receiver && <h5>Receiver's ID: {receiver}</h5>}

            {receiver && <button onClick={() => sharePaste()}>{ loading ? 'sending...' : 'share now!' }</button>}
        </>
    )
}